import { Component, Input, OnInit } from '@angular/core';
import { ViewWillEnter } from '@ionic/angular';
import { ActivatedRoute, Route, Router } from '@angular/router';
import { GarmnetPickupService } from '../../../../services/garment-pickup.service';
import { ToasterService } from '../../../../../../../app/common/services/toaster.service';

@Component({
  selector: 'app-garment-pick-up-page',
  templateUrl: 'garment-pick-up.page.html',
  styleUrls: [
     './garment-pick-up.page.scss',
     '../../../../styles/g-route.styles.scss'
  ]
})
export class GarmentPickUpPage implements ViewWillEnter, OnInit {

    currentRoute: string;
    stopName: string;
    showScansList: boolean = false;
    showScanner: boolean = true;
    garmentCodes: string;
    garmentList: any;
    breadcrumbs=[];
    routeStopName: string = "";
    loaded:boolean=true;

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private garmentPickupService: GarmnetPickupService,
        private toasterService: ToasterService
    ) { 
        this.currentRoute = null;
    }

    ngOnInit(): void {
        this.loaded=false;
        this.currentRoute = this.router.url;
        this.stopName = this.route.snapshot.paramMap.get('id');
        this.routeStopName = localStorage.getItem('routeStopName');
        this.breadcrumbs.push({ label: 'Home', url: '/route' });
        this.breadcrumbs.push({ label: 'Logsheet', url: '/route/logsheet' });
        this.breadcrumbs.push({ label: 'Stop', url: '/route/logsheet/stop/'+ this.stopName });
        window.dispatchEvent(new Event('resize'));
        this.loaded=true;
    }

    ionViewWillEnter(): void {
        
    }

    async savePickUp() {
        this.loaded=false;
        this.showScansList = false;
        if(this.garmentCodes==null){
            this.toasterService.presentToast('danger', '', 'Please enter garment code')
              this.loaded=true;
            return;
        }
      var result=  await this.garmentPickupService.PickUpGarment(this.garmentCodes);
      this.garmentList= Array.isArray(result) ? result : (result ? [result] : []);
      if( this.garmentList !=null){
      this.showScansList = true;
        this.garmentCodes = "";
        this.toasterService.presentToast('primary', '', 'Garment pick up processed successfully')
      }
      else{
        this.toasterService.presentToast('danger', '', 'Garment code not found')
      }
        this.loaded=true;
    }

    scanner() {
        this.showScanner = true;
        this.showScansList = false;
    }

    showScans(event: any) {
        this.loaded=false;
        this.showScansList = true;
        this.showScanner = false;
        //get date and set to format yyyy-mm-dd
        let selectedDate = event.detail.value.split('T')[0]

        //get garment list for selected date and stop
        this.garmentPickupService.GetGarmentList(selectedDate, this.stopName).then((data) => {
            this.garmentList = data;
        });
        this.loaded=true;
    }

}